import { render, staticRenderFns } from "./prefeiturasp.vue?vue&type=template&id=1134b2bb"
import script from "./prefeiturasp.vue?vue&type=script&lang=js"
export * from "./prefeiturasp.vue?vue&type=script&lang=js"
import style0 from "./prefeiturasp.vue?vue&type=style&index=0&id=1134b2bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports